import Request from "../../../utils/Request"
import { AxiosResponse } from "axios"

/**
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 * @constructor
 */
const RequestAccess = (data:any[] = false): Promise<AxiosResponse<T>> => {
	return Request.post("/advisors/individuals_ifa/request-access", data);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export default RequestAccess
